export default "__VITE_ASSET__2cc55075__"